import { Award } from 'lucide-react';

// Founding Member status badge — a status, not a discount.
export const FoundingMemberBadge = ({ compact = false }) => {
  if (compact) {
    return (
      <span
        className="inline-flex items-center gap-1 bg-amber-100 text-amber-900 text-[10px] font-bold px-2 py-0.5 rounded-full"
        data-testid="founding-member-badge-compact"
        title="Founding Member — permanent 48-hour early workshop registration"
      >
        <Award size={10} /> Founding
      </span>
    );
  }
  return (
    <span
      className="inline-flex items-center gap-1.5 bg-amber-100 text-amber-900 text-xs font-bold px-3 py-1 rounded-full"
      data-testid="founding-member-badge"
      title="Permanent 48-hour early workshop registration access"
    >
      <Award size={13} /> Founding Member
    </span>
  );
};

export default FoundingMemberBadge;
